import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=af0bfe76"
import script from "./Countdown.vue?vue&type=script&lang=ts"
export * from "./Countdown.vue?vue&type=script&lang=ts"
import style0 from "./Countdown.vue?vue&type=style&index=0&id=af0bfe76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports